<p-toolbar class="kleros-toolbar">
  <ng-template pTemplate="start">
    <div class="flex align-items-center gap-2">
      <img [src]="userInfoData?.azienda?.palette?.logo || '../../../../assets/img/loghi/logo_navbar.png'"
           alt="logo" class="hidden lg:block navbar-logo"/>
      <p-button class="inline-flex justify-content-center align-items-center text-white nav-item-padding border-noround bg-transparent"
                styleClass="p-0" [text]="true" [pTooltip]="'applicazioni'|translate" tooltipPosition="bottom" routerLink="applicazioni">
        <i class="mdi mdi-apps text-3xl"
           [class.text-color]="router.url !== '/applicazioni'"
           [class.text-primary]="router.url === '/applicazioni'">
        </i>
      </p-button>
      @let notifiche = state.listaNotifiche.asObservable()|async;
      @let notificheLette = state.notificheLette.asObservable()|async;
      @if (notifiche?.length) {
        <i class="cursor-pointer mdi" [ngClass]="notificheLette ? 'mdi-bell text-white' : 'mdi-bell-ring text-danger'"
           (click)="notificheTextPO.show($event)">
        </i>
        <p-popover #notificheTextPO (onHide)="state.setNotificheLette(true)" styleClass="notifiche-popover">
          <ul class="notifiche-list">
            @for (notifica of notifiche; track notifica.chiave) {
              <li class="notifica-item">
                <div class="notifica-testo" [innerHTML]="state.getNotificationText(notifica, translate.currentLang)"></div>
              </li>
            }
            <div class="flex justify-content-end mt-2">
              <p-button type="button" label="OK" size="small" [text]="true" (click)="notificheTextPO.hide()"></p-button>
            </div>
          </ul>
        </p-popover>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="center">
    @if (!hideNavItems && state.currentActiveAppId) {
      <div class="flex flex-wrap align-items-center justify-content-center">
        @let uncompletedSections = validationService.sectionsUncompleted();
        @for (item of navbarService.navbarItems$|async; track item.routerLink) {
          <div class="flex flex-column hover:bg-white-alpha-10 transition-all transition-duration-200"
               [class.border-danger-navitem]="uncompletedSections.includes(item.funzione)">
            @if (!item.children) {
              <navbar-link [navbarItem]="item"
                           [disabled]="!item.alwaysActive &&
                                        FunzioniKleros.FAMIGLIA_DOSSIER !== item.funzione && FunzioniKleros.FAMIGLIA !== item.funzione
                                        && disableFunctions">
              </navbar-link>
            } @else {
              <div class="p-link inline-flex justify-content-center align-items-center text-white nav-item-padding border-noround"
                   [class.item-navbar-active]="router.url.includes(item.routerLinkActivePath)"
                   (click)="menuItemsOP.show($event)">
                <div class="flex flex-column align-items-center justify-content-center">
                  <i [class]="item.icon" class="nav-item-icon"></i>
                  <span class="nav-item-text" [class.item-active]="router.url.includes(item.routerLinkActivePath)">
                    {{ item.label }}
                  </span>
                </div>
                <span class="mdi mdi-chevron-down"></span>
              </div>
              <p-popover #menuItemsOP styleClass="bg-bluegray-300 no-side-padding">
                @for (child of item.children; track child.routerLink) {
                  <div class="flex flex-column hover:bg-white-alpha-10 transition-all transition-duration-200"
                       [class.border-danger-navitem]="uncompletedSections.includes(item.funzione)" (click)="menuItemsOP.hide()">
                    <navbar-link [navbarItem]="child" [isChildren]="true"
                                 [disabled]="!item.alwaysActive &&
                                              FunzioniKleros.FAMIGLIA_DOSSIER !== item.funzione && FunzioniKleros.FAMIGLIA !== item.funzione
                                              && disableFunctions">
                    </navbar-link>
                  </div>
                }
              </p-popover>
            }
          </div>
        }
      </div>
    }
    @if (isURLDossierMyarpa) {
      <div class="flex flex-wrap align-items-center justify-content-center gap-3">
        <div class="flex flex-column hover:bg-white-alpha-10 transition-all transition-duration-200 cursor-pointer">
          <div class="p-link inline-flex justify-content-center align-items-center text-white nav-item-padding border-noround"
               [routerLink]="'applicazioni/' + state.currentActiveAppId + '/dossier'"
               routerLinkActive="item-navbar-active" [routerLinkActiveOptions]="{exact: true}">
            <div class="flex flex-column align-items-center justify-content-center px-1">
              <i class="mdi mdi-folder-open nav-item-icon"></i>
              <span class="nav-item-text" routerLinkActive="item-active" [routerLinkActiveOptions]="{exact: true}">
                {{ 'selezione_dossier'|translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>
  <ng-template pTemplate="end">
    <div class="flex align-items-center gap-3 navbar-end">
      @if (openDossier) {
        <div class="flex gap-2 align-items-center">
          @if (openDossier.readOnly) {
            <i class="mdi mdi-folder-search text-danger" [pTooltip]="'modalitaVisualizzazione'|translate" tooltipPosition="left"></i>
          }
          @if (state.isMyarpaAnonimo || state.dossierReadonly) {
            @if (!hideNavItems && state.isMyArpaAppOpen(state.activeApp)) {
              <span class="font-bold text-white">
                {{ openDossier?.userDossier?.codice }}
              </span>
            }
          } @else if (state.isMyarpaDossier && !state.dossierReadonly) {
            <div class="cursor-pointer gap-2 flex align-items-center navbar-btn" pRipple
                 [pTooltip]="'documentiDossier'|translate" tooltipPosition="left"
                 (click)="menuDossier.toggle($event)">
              <i class="mdi mdi-folder-open-outline" [class.text-secondary-color]="router.url.includes('/documenti')"></i>
              @if (!hideNavItems && state.isMyArpaAppOpen(state.activeApp)) {
                <span class="font-bold font-small" [class.text-primary]="router.url.includes('/documenti')">
                  {{ openDossier?.userDossier?.codice }}
                </span>
              }
              <i class="mdi mdi-chevron-down transition-transform" [class.rotate-180]="menuDossierOpened"></i>
            </div>
          }
        </div>
      }

      @if (loadingWallets) {
        <p-progressSpinner strokeWidth="3" class="w-2rem h-2rem"/>
      } @else if (wallets?.length || menuGestionePortafoglioItems?.length) {
        <div class="cursor-pointer gap-2 flex align-items-center navbar-btn-no-padding" style="padding: 0.35rem 0.75rem"
             [pTooltip]="'gestionePortafoglio'|translate" tooltipPosition="left"
             (click)="menuGestionePortafoglio.toggle($event)">
          <i class="pi pi-wallet"></i>
          @for (wallet of wallets; track wallet.id) {
            <div class="flex align-items-center gap-1">
              <div class="flex align-items-center gap-1" [class]="getWalletColorClass(wallet)">
                <span class="font-bold font-small" [class]="getWalletColorClass(wallet)">{{ wallet.currentBalance + ' €' }}</span>
              </div>
            </div>
            @if (!$last) {
              /
            }
          }
          <i class="mdi mdi-chevron-down transition-transform" [class.rotate-180]="menuGestionePortafoglioOpened"></i>
        </div>
      }

      <!-- navbar-avatar: anello chiaro al passaggio del mouse e mentre il menù è aperto (fa capire che è cliccabile) -->
      <p-avatar [icon]="'fi fi-' + translate.currentLang" shape="circle" class="cursor-pointer navbar-avatar"
                [class.navbar-avatar-aperto]="menuLangOpened"
                [pTooltip]="('lingua'|translate) + ': ' + nomeLinguaCorrente" tooltipPosition="left"
                (click)="menuLang.toggle($event)"/>

      @if (account.hasAnyProfilo([TipoProfilo.ADMIN, TipoProfilo.RESPONSABILE])) {
        <p-avatar icon="pi pi-cog" shape="circle" class="cursor-pointer navbar-avatar" pRipple
                  [pTooltip]="'configurazione'|translate" tooltipPosition="left"
                  [class.avatar-active]="router.url.includes('/configurazione/')"
                  [class.navbar-avatar-aperto]="menuDominioOpened"
                  (click)="menuDominio.toggle($event)"/>
      }

      <!-- l'hover vale su tutto il blocco (avatar + nome + freccia); la freccia, come per dossier e portafoglio, ruota col
           menù aperto e sotto i 1500px sparisce insieme al nome (resta solo l'avatar, v. navbar-utente-nome) -->
      <div class="flex align-items-center gap-2 cursor-pointer navbar-utente" (click)="menuUtente.toggle($event)">
        <p-avatar icon="pi pi-user" shape="circle" class="navbar-avatar" [class.avatar-active]="router.url.includes('/user-profile')"
                  [class.navbar-avatar-aperto]="menuUtenteOpened"/>
        <span class="font-bold text-white navbar-utente-nome">{{ account.nomeCognomeUser$|async }}</span>
        <i class="mdi mdi-chevron-down text-white transition-transform navbar-utente-nome" [class.rotate-180]="menuUtenteOpened"></i>
      </div>

    </div>

    <p-menu [model]="menuConfigurazioneItems" #menuDominio [popup]="true" [baseZIndex]="99999"
            (onShow)="menuDominioOpened = true"
            (onHide)="menuDominioOpened = false; cdRef.detectChanges();">
    </p-menu>

    <p-menu [model]="menuUtenteItems" #menuUtente [popup]="true" [baseZIndex]="99999"
            (onShow)="menuUtenteOpened = true"
            (onHide)="menuUtenteOpened = false; cdRef.detectChanges();">
    </p-menu>

    <p-menu [model]="menuDossierItems" #menuDossier [popup]="true" [baseZIndex]="99999"
            (onShow)="menuDossierOpened = true"
            (onHide)="menuDossierOpened = false; cdRef.detectChanges();">
    </p-menu>

    <p-menu [model]="langMenu" #menuLang [popup]="true" [baseZIndex]="99999"
            (onShow)="menuLangOpened = true"
            (onHide)="menuLangOpened = false; cdRef.detectChanges();">
    </p-menu>

    <p-menu [model]="menuGestionePortafoglioItems" #menuGestionePortafoglio [popup]="true" [baseZIndex]="99999"
            (onShow)="menuGestionePortafoglioOpened = true"
            (onHide)="menuGestionePortafoglioOpened = false; cdRef.detectChanges();">
    </p-menu>

  </ng-template>
</p-toolbar>
